/**
 * qualityPriceApi — RTK Query slice cho /purchase/quality-price/* (Procurement).
 * Read-only: Quality Price vs Basis datasheet, lọc theo 1 ngày (date_actual).
 */
import { baseApi } from './baseApi'
import type { PageResponse } from '@/types/api'

export interface QualityPriceItem {
  dateActual: string | null
  code: string | null
  qualityPremiumRaw: number | null
  price: number | null
  priceFromG2: number | null
  fx: number | null
  maxDateUpdates: string | null
  priceUnit: string | null
}

export const qualityPriceApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listQualityPrice: b.query<PageResponse<QualityPriceItem>, { date: string }>({
      query: ({ date }) => ({ url: '/purchase/quality-price/list', params: { date } }),
    }),
  }),
})

export const { useListQualityPriceQuery } = qualityPriceApi
